<template>
  <van-form class="yunxiao class-paike-add week-paike-date" input-align="right">
    <van-cell class="time-cell-item" v-for="(time, tIdx) of value.times" :key="tIdx">
      <template #title>
        <div class="time-arrage-title">
          <van-icon
            v-if="value.times.length > 1"
            class="delete-icon"
            class-prefix="vxs-icon"
            name="system_del"
            color="var(--c3)"
            @click="deleteTimes(tIdx)"
          />
          <van-field
            class="weekday-input"
            readonly
            :class="{ chooseing: showWeekDayPick && listIndex === tIdx }"
            v-model="time.weekdayName"
            right-icon="arrow-down"
            placeholder="星期"
            input-align="left"
            @click="choiceWeekDay(tIdx)"
          />
        </div>
      </template>
      <template>
        <div class="time-arrage-value" @click="choiceDatetime(time)">
          <div v-if="time.startTime && time.endTime" class="van-ellipsis" style="color: var(--g8)">
            <span>{{ time.startTime }}～{{ time.endTime }}</span>
            <span class="time-arrage-minutes">{{
              app.tool.date.getDiffTimeDesc(time.startTime, time.endTime)
            }}</span>
          </div>
          <div v-else>请选择</div>
          <div class="always-tag tlc" @click.stop="chooseCommonTimePeriods(time)">常用时段</div>
        </div>
      </template>
    </van-cell>
    <van-cell class="add-time-arrage-cell">
      <template #title>
        <div class="add-time-arrage" @click="addMoreTimes(value.times)">
          <i class="vxs-icon vxs-icon-system_add"></i>添加时段
        </div>
      </template>
    </van-cell>
    <!-- <van-field
      readonly
      clickable
      input-align="right"
      label="是否重复排课"
      placeholder="请选择"
      :right-icon="'arrow'"
      @click.stop="selectFildClick('repeatType', value.repeatType)"
    >
      <template #input>
        <div  class="van-ellipsis" style="color: var(--g8)">
          {{ repeatTypeStus[value.repeatType].itemName }}
        </div>
      </template>
    </van-field> -->
    <van-field
      readonly
      clickable
      input-align="right"
      label="开始排课日期"
      placeholder="请选择"
      :right-icon="'arrow'"
      @click.stop="showOpenDatePicker = true"
    >
      <template #input>
        <div v-if="value.startDate" class="van-ellipsis" style="color: var(--g8)">
          {{ app.tool.date.formatDatetime(value.startDate, 'yyyy-MM-dd') }}
        </div>
        <div v-else style="color: var(--g6)">请选择</div>
      </template>
    </van-field>

    <!-- <van-field class="title-108" readonly input-align="right" label="是否重复排课">
      <template #input>
        <van-radio-group v-model="value.repeatType" direction="horizontal">
          <van-radio name="0">不重复</van-radio>
          <van-radio name="1">按周重复</van-radio>
        </van-radio-group>
      </template>
    </van-field> -->
    <van-field
      readonly
      clickable
      input-align="right"
      label="排课结束方式"
      placeholder="请选择"
      :right-icon="'arrow'"
      v-if="value.repeatType === '1'"
      @click.stop="selectFildClick('repeatEndType', value.repeatEndType)"
    >
      <template #input>
        <div class="van-ellipsis" style="color: var(--g8)">
          {{ repeatEndTypeStus[value.repeatEndType].itemName }}
        </div>
      </template>
    </van-field>
    <template v-if="value.repeatType === '1'">
      <van-field
        v-if="value.repeatEndType === '0'"
        input-align="right"
        label="排课节数"
        placeholder="请输入"
        :border="false"
      >
        <template #input>
          <div class="field-times">
            <van-stepper v-model="value.lessonCount" min="1" max="366" integer />
            <div class="field-times-tips" @click.stop="showPreviewHandler">预览排课结果</div>
          </div>
        </template>
      </van-field>
      <van-field
        v-else
        readonly
        clickable
        input-align="right"
        :class="{ 'end-time-field': Boolean(value.endDate) }"
        label="排课结束日期"
        placeholder="请选择"
        :right-icon="'arrow'"
        @click.stop="toShowEndDatePicker"
      >
        <template #input>
          <div class="field-times" v-if="value.endDate">
            <div class="van-ellipsis" style="color: var(--g8)">
              {{ app.tool.date.formatDatetime(value.endDate, 'yyyy-MM-dd') }}
            </div>
            <div class="field-times-tips" @click.stop="showPreviewHandler">预览排课结果</div>
          </div>
          <div v-else style="color: var(--g6)">请选择</div>
        </template>
      </van-field>
    </template>

    <!-- 使用getContainer将sheet挂载到body, 避免ios上会处理其它元素层级之下的问题-->
    <van-action-sheet
      get-container="body"
      v-model="showWeekDayPick"
      :actions="weekdayArr"
      @select="onSelectWeekDay"
    />
    <van-calendar
      get-container="body"
      color="var(--c1)"
      :min-date="minStartDate"
      :max-date="new Date(2030, 11, 31)"
      :default-date="!value.startDate ? new Date() : new Date(value.startDate)"
      v-model="showOpenDatePicker"
      @confirm="openDatePickerConfirm"
    />
    <van-calendar
      get-container="body"
      color="var(--c1)"
      :min-date="minEndDate"
      :max-date="maxEndDate"
      :default-date="!value.endDate ? new Date() : new Date(value.endDate)"
      v-model="showEndDatePicker"
      @confirm="endDatePickerConfirm"
    />
    <van-popup
      v-model="showSelectPicker"
      position="bottom"
      :style="{ height: '50%' }"
      :safe-area-inset-bottom="true"
      getContainer="body"
    >
      <van-picker
        title="请选择"
        show-toolbar
        :columns="actions"
        @confirm="onSelect"
        value-key="itemName"
        :default-index="actionsIdx"
        @cancel="showSelectPicker = false"
      />
    </van-popup>
    <van-popup
      v-model="showPreviewDate"
      closeable
      round
      position="bottom"
      :style="{ height: '45%' }"
      :safe-area-inset-bottom="true"
      getContainer="body"
    >
      <div class="week-paike-date-preview-date-container">
        <p class="preview-date-title">预览排课结果（{{ previewDateList.length }}）</p>
        <div class="main">
          <table class="preview-date-table">
            <thead>
              <tr>
                <th class="text-left">日期</th>
                <th class="text-left">时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in previewDateList" :key="index">
                <td>
                  {{ item.arrangeDate | formatDatetime('yyyy-MM-dd') }} (周{{
                    ['', '一', '二', '三', '四', '五', '六', '日'][item.weekDay]
                  }})
                </td>
                <td>{{ item.startTime }}-{{ item.endTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </van-popup>
  </van-form>
</template>
<script>
function timeGetTime(str) {
  return Number(str.substr(0, 2) + str.substr(3, 2));
}
// const repeatTypeStus = [
//   {val: '0', id: 0, itemName: '不重复'},
//   {val: '1', id: 1, itemName: '按周重复'}
// ]
const repeatEndTypeStus = [
  { val: '0', id: 0, itemName: '按排课节数' },
  { val: '1', id: 1, itemName: '按排课结束日期' },
];
export default {
  name: 'weekPaikeDate',
  props: {
    value: Object,
    typeStr: {
      type: String,
      default: '排课',
    },
    minStartDate: {
      type: Date,
      default: () => new Date('2020/01/01'),
    },
  },
  data() {
    return {
      actionsIdx: -1,
      listIndex: -1,
      showWeekDayPick: false,
      // repeatTypeStus,
      repeatEndTypeStus,
      minEndDate: new Date(),
      maxEndDate: new Date(),
      weekdayArr: [
        { name: '星期一', id: 1 },
        { name: '星期二', id: 2 },
        { name: '星期三', id: 3 },
        { name: '星期四', id: 4 },
        { name: '星期五', id: 5 },
        { name: '星期六', id: 6 },
        { name: '星期日', id: 7 },
      ],
      showOpenDatePicker: false,
      showEndDatePicker: false,
      showSelectPicker: false,
      actions: [],
      previewDateList: [],
      showPreviewDate: false,
    };
  },
  computed: {
    timeValidate() {
      return this.value.times.every(item => {
        if (item.startTime === '' || item.endTime === '' || item.weekday == '') {
          return false;
        }
        return true;
      });
    },
  },
  methods: {
    choiceWeekDay(index) {
      // 打开选择星期弹窗
      this.listIndex = index;
      this.showWeekDayPick = true;
    },
    onSelectWeekDay(val) {
      // 选择星期
      this.value.times[this.listIndex].weekdayName = val.name;
      this.value.times[this.listIndex].weekday = val.id;
      this.showWeekDayPick = false;
    },
    addMoreTimes(times) {
      let lastTime = times.slice(-1)[0];
      if (!lastTime || !lastTime.weekday) {
        return times.push({
          startTime: '',
          endTime: '',
          weekdayName: '',
          weekday: '',
        });
      }
      let weekdayObjs = this.weekdayArr[lastTime.weekday];

      times.push({
        startTime: lastTime.startTime,
        endTime: lastTime.endTime,
        weekdayName: weekdayObjs ? weekdayObjs.name : '',
        weekday: weekdayObjs ? weekdayObjs.id : '',
      });
    },
    choiceDatetime(time) {
      app.x3.picker
        .timeInterval({
          value1: time.startTime,
          value2: time.endTime,
        })
        .then(res => {
          time.startTime = res.value1;
          time.endTime = res.value2;
        });
    },
    // 常用时段
    async chooseCommonTimePeriods(time) {
      const res = await app.x3.side.xsTimePeriods({
        config: {
          radio: true,
        },
      });
      Object.assign(time, res);
    },
    openDatePickerConfirm(v) {
      if (this.value.endDate && v > new Date(this.value.endDate)) {
        vant.Toast(`排课开始日期不可晚于结束日期，请重新选择`);
        return false;
      }
      // 打开日期弹窗
      this.value.startDate = v;
      this.showOpenDatePicker = false;
    },
    toShowEndDatePicker() {
      if (!this.value.startDate) {
        vant.Toast(`请先选择开始${this.typeStr}日期`);
        return false;
      }
      this.minEndDate = new Date(this.value.startDate);
      this.maxEndDate = app.tool.date.getBasedOnToDayDate(366, 'Date', new Date(this.minEndDate));
      this.showEndDatePicker = true;
    },
    endDatePickerConfirm(v) {
      // 打开日期弹窗
      this.value.endDate = v;
      this.showEndDatePicker = false;
    },
    timesVerify(verifyBeforeDate) {
      if (!this.value.startDate) {
        vant.Toast(`请选择开始${this.typeStr}日期`);
        return false;
      }
      if (this.value.repeatEndType === '1' && !this.value.endDate) {
        vant.Toast(`请选择结束日期`);
        return false;
      }
      if (this.value.repeatEndType !== '1' && !this.value.lessonCount) {
        this.value.lessonCount !== '' && vant.Toast.fail('排课次数请输入1~99的整数');
        return false;
      }

      // 校验上课时段是否有空值
      if (!this.timeValidate) {
        vant.Toast('上课时段不能为空');
        return false;
      }
      // 校验上课时段是否有重合
      let result = true;
      let tims = this.value.times;
      for (let i = 0; i < tims.length; i++) {
        // 验证不能选择过去时间
        if (verifyBeforeDate) {
          if (
            app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd') ===
            app.tool.date.formatDatetime(new Date(this.value.startDate), 'yyyy-MM-dd')
          ) {
            let currenHour = app.tool.date.formatDatetime(new Date(), 'hh:mm');
            let currentDay = new Date().getDay() ? new Date().getDay() : 7;
            if (
              currentDay === tims[i].weekday &&
              timeGetTime(tims[i].startTime) < timeGetTime(currenHour)
            ) {
              vant.Toast('发布约课的时段不可早于当前时间');
              return false;
            }
          }
        }
        for (let j = i + 1; j < tims.length; j++) {
          if (tims[i].weekday == tims[j].weekday) {
            if (timeGetTime(tims[i].startTime) < timeGetTime(tims[j].startTime)) {
              if (timeGetTime(tims[i].endTime) > timeGetTime(tims[j].startTime)) {
                result = false;
                break;
              }
            } else {
              if (timeGetTime(tims[i].startTime) < timeGetTime(tims[j].endTime)) {
                result = false;
                break;
              }
            }
          }
          if (!result) break;
        }
      }
      if (!result) {
        vant.Toast.fail('上课时段有冲突');
        return false;
      } else {
        return true;
      }
    },
    selectFildClick(fieldName, val) {
      this.selectFildName = fieldName;
      this.actions = [...repeatEndTypeStus];
      this.actionsIdx = 0;
      if (val) {
        let idx = this.actions.findIndex(v => v.val == val);
        this.actionsIdx = idx;
      }
      this.showSelectPicker = true;
    },
    onSelect(selectItems) {
      this.showSelectPicker = false;
      this.$set(this.value, this.selectFildName, selectItems.val);
      // 如果是选择结束方式，需要清楚或者获取结束时间
      this.showSelectPicker = false;
      this.value.lessonCount = '';
      this.value.endDate = '';
    },
    deleteTimes(idx) {
      this.value.times.splice(idx, 1);
    },
    // getTimeList () {
    //   let timeList = [];
    //   let { repeatEndType, lessonCount, times, startDate, endDate } = this.value;
    //   let startDateWeekday = startDate.getDay() || 7;
    //   let sortTimes = [...times].sort((a,b)=>a.weekday-b.weekday)
    //   if (repeatEndType === '0') {
    //     let weeks = 0;
    //     for (;weeks<lessonCount;weeks++) {
    //       for (let time of sortTimes) {
    //         let weekday = time.weekday + 7 * weeks;
    //         if (weekday>=startDateWeekday) {
    //           let date = new Date(startDate);
    //           date = new Date(date.setDate(date.getDate() + (weekday-startDateWeekday)));
    //           timeList.push({ ...time, date: app.tool.date.formatDatetime(date, 'yyyy-MM-dd')})
    //         }
    //         if (timeList.length>=lessonCount) return timeList
    //       }
    //     }
    //     return timeList;
    //   } else{
    //     let weeks = 0;
    //     let days = Math.ceil((new Date(endDate) - new Date(startDate))/1000/60/60/24);
    //     let repeatTimes = Math.ceil(days/7)
    //     for (;weeks<=repeatTimes;weeks++) {
    //       for (let time of sortTimes) {
    //         let weekday = time.weekday + 7 * weeks;
    //         if (weekday-time.weekday>days) return timeList
    //         if (weekday>=startDateWeekday) {
    //           let date = new Date(startDate);
    //           date = new Date(date.setDate(date.getDate() + (weekday-startDateWeekday)));
    //           timeList.push({ ...time, date: app.tool.date.formatDatetime(date, 'yyyy-MM-dd')})
    //         }
    //       }
    //     }
    //     return timeList;
    //   }
    // },
    showPreviewHandler() {
      if (this.timesVerify()) {
        let { lessonCount, startDate, times, repeatEndType, endDate } = this.value;
        let previewParams = {
          startTime: app.tool.date.formatDatetime(startDate, 'yyyy-MM-dd'),
          repeatEndType,
          weeklyPlanDetailList: [...times],
        };
        if (repeatEndType === '1') {
          previewParams.endTime = app.tool.date.formatDatetime(endDate, 'yyyy-MM-dd');
        } else {
          previewParams.lessonCount = lessonCount;
        }
        if (
          this._ajax_getEndDate_params &&
          this._ajax_getEndDate_params === JSON.stringify(previewParams)
        ) {
          this._ajax_getEndDate.then(res => {
            if (res.code == 200) {
              this.$toast.clear();
              this.showPreviewDate = true;
            }
          });
          return false;
        }
        this.showLoading();
        this._ajax_getEndDate = this.$api.courseArrangePlanPreview(previewParams);
        this._ajax_getEndDate_params = JSON.stringify(previewParams);
        this._ajax_getEndDate
          .then(res => {
            if (res.code == 200) {
              this.$toast.clear();
              this.previewDateList = res.data.previewList || [];
              this.showPreviewDate = true;
              !res.data.previewList && (this._ajax_getEndDate_params = '');
              return false;
            }
            if (res.code > 60000) {
              app.http.tipErr(res.msg || '网络异常，请稍后重试');
            }
          })
          .catch(err => {
            console.log(err);
            this._ajax_getEndDate_params = '';
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.yunxiao.class-paike-add.week-paike-date {
  margin: calc(var(--gap) * 16) calc(var(--gap) * 12);
  padding: 0 calc(var(--gap) * 16);
  background-color: var(--white);
  border-radius: var(--radius-sm);
  .time-arrage-title {
    display: flex;
    i {
      margin-right: calc(var(--w) * 8);
    }
  }
  .time-arrage-value {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: var(--g5);
    .time-arrage-minutes {
      font-size: var(--fs-sm);
      margin-left: calc(var(--gap) * 12);
    }
    i {
      margin-left: 8px;
    }
  }
  .always-tag {
    color: var(--c1);
    margin-left: calc(var(--gap) * 8);
  }
  .weekday-input {
    margin: 0;
    padding: 0;
    width: calc(var(--w) * 72);
    color: var(--g8);
    border-color: var(--g3);
    border-width: 0 1px 0 0;
  }
  .add-time-arrage {
    color: var(--tlc);
    i {
      margin-right: calc(var(--gap) * 4);
    }
  }
  .field-times-tips {
    padding-top: calc(var(--gap) * 4);
    text-align: right;
    color: var(--c1);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    background: var(--white);
  }
  .end-time-field {
    position: relative;
    padding-bottom: calc(var(--gap) * 32);
    .field-times-tips {
      position: absolute;
      right: calc(var(--gap) * 24);
      text-align: right;
    }
  }
}
</style>
<style lang="scss">
.yunxiao.class-paike-add.week-paike-date {
  .van-cell,
  .van-field {
    padding: calc(var(--gap) * 15) 0;
    &::after {
      right: 0;
      left: 0;
    }
  }
  .van-cell__title {
    width: calc(var(--w) * 128);
    flex: unset;
  }
  .van-cell.time-cell-item .van-cell__title,
  .van-cell.title-108 .van-cell__title {
    width: calc(var(--w) * 95);
  }
  .van-cell__title,
  .van-field__label,
  .van-field__value,
  .van-cell__value {
    font-size: var(--fs-md);
    color: var(--g8);
  }
  .van-cell__value .van-radio--horizontal:last-child {
    margin-right: 0;
  }
  .van-cell__title,
  .van-field__label {
    color: var(--g7);
  }
  .weekday-input {
    .van-icon-arrow-down {
      transition: all 0.3s;
    }
    &.chooseing .van-icon-arrow-down {
      transform: rotateZ(180deg);
    }
  }
}
.week-paike-date-preview-date-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .preview-date-title {
    margin: calc(var(--gap) * 14) auto calc(var(--gap) * 12);
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    text-align: center;
    color: var(--g8);
    font-weight: var(--bold);
  }
  .main {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    flex: 1;
    overflow-y: auto;
    .preview-date-table {
      width: 100%;
      border-collapse: collapse;
      th {
        background-color: var(--g2);
        text-align: left;
      }
      th,
      td {
        padding: calc(var(--gap) * 8) 0 calc(var(--gap) * 8) calc(var(--gap) * 20);
      }
      tr:nth-child(2n) {
        background-color: rgba(var(--g1-rgb), 0.8);
      }
    }
  }
}
</style>